/* Klenava yapışkan sepet çubuğu: ana "Sepete Ekle" butonu ekranın üstüne çıkınca görünür. */
class KlenavaStickyCart extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-add]');
    this.priceEl = this.querySelector('[data-price]');
    this.ticking = false;
    this.onScroll = () => {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    };
    this.onClick = () => {
      const target = this.target();
      if (target && !target.disabled) target.click();
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    this.button.addEventListener('click', this.onClick);

    const info = document.querySelector('product-info');
    if (info && 'MutationObserver' in window) {
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(info, { childList: true, subtree: true, characterData: true });
    }
    this.sync();
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    if (this.button) this.button.removeEventListener('click', this.onClick);
    if (this.observer) this.observer.disconnect();
  }

  target() {
    return document.querySelector('product-info .product-form__submit');
  }

  update() {
    const target = this.target();
    const show = Boolean(target) && target.getBoundingClientRect().bottom < 0;
    this.classList.toggle('is-visible', show);
    this.setAttribute('aria-hidden', String(!show));
    this.button.tabIndex = show ? 0 : -1;
  }

  sync() {
    const target = this.target();
    const priceBox = document.querySelector('product-info [id^="price-"]');
    if (priceBox && this.priceEl) {
      const item = priceBox.querySelector('.price-item--sale') || priceBox.querySelector('.price-item--regular');
      if (item && item.textContent.trim()) this.priceEl.textContent = item.textContent.trim();
    }
    if (target) {
      this.button.disabled = target.disabled;
      const label = target.querySelector('span');
      if (label && label.textContent.trim()) this.button.textContent = label.textContent.trim();
    }
  }
}

if (!customElements.get('klenava-sticky-cart')) {
  customElements.define('klenava-sticky-cart', KlenavaStickyCart);
}
